import { IDevDebugVisibleInput } from "@/hooks/useDevDebugVisible/types"

export const isDevDebugVisible = ({
  isDevBuild,
  isDebug
}: IDevDebugVisibleInput): boolean => isDevBuild && isDebug
